<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {usePiniaStore} from "../store/pinia_store";
import _, {isEmpty} from "lodash";

const props = defineProps({
    crmId: {
        type: String,
        required: true,
    },
    eventBus: {
        type: Object,
        required: true,
    },
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
})

const piniaStore = usePiniaStore();
const currentFavorites = ref(null)
const loading = ref(false);

const isFavorite = computed(() => {
    if (isEmpty(currentFavorites.value) || isEmpty(currentFavorites.value.lines)) {
        return false;
    }

    for (const currentFavorite of currentFavorites.value.lines) {
        if (currentFavorite.sku === props.crmId) {
            return true;
        }
    }

    return false;
})

const handleClick = () => {
    loading.value = true;

    if (isFavorite.value) {
        removeFavorite();

        return;
    }

    addFavorite();
}
const removeFavorite = () => {
    props.dentaidApiInstance.post(`/favorites/delete?token=${piniaStore.parsedToken}`, {
        items: {
            0: {
                sku: props.crmId
            }
        }
    })
        .then(response => {
            piniaStore.updateUserData(response.data.data);

            currentFavorites.value = piniaStore.favorites;
        }).finally(() => loading.value = false);
}

const addFavorite = () => {
    props.dentaidApiInstance.post(`/favorites?token=${piniaStore.parsedToken}`, {
        items: {
            0: {
                sku: props.crmId
            }
        }
    }).then(response => {
        piniaStore.updateUserData(response.data.data);

        currentFavorites.value = piniaStore.favorites;
    }).finally(() => loading.value = false);
}

watch(() => piniaStore.isLoading, () => {
    currentFavorites.value = piniaStore.favorites;
}, {deep: true})

onMounted(() => {
    currentFavorites.value = piniaStore.favorites;
})
</script>

<template>
    <div class="vue-product-favorite">
        <button @click="handleClick" :disabled="loading" class="btn-ghost btn-favorite"
                :class="{'favorite': isFavorite}">
            <template>
                <dentaid-favorite-icon></dentaid-favorite-icon>
            </template>
        </button>
    </div>
</template>
